import script from "./ContactDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ContactDialog.vue?vue&type=style&index=0&id=0851e52a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0851e52a"]])

export default __exports__